import React, { useState } from "react";
import {
  Box,  
  Menu,
  MenuItem,
  Typography,
  ListItemIcon,
  Tooltip,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import { colors, spacing, typography } from "../theme";

export default function UserMenu({
  username,
  onLogout,
  hideLabel = false,
}: {
  username: string;
  onLogout: () => void;
  hideLabel?: boolean;
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title={hideLabel ? username : ""} placement="right">
        <Box
          onClick={handleClick}
          sx={{
            alignSelf: 'stretch',
            padding: hideLabel ? spacing.mui.md : spacing.mui.lg,
            paddingLeft: hideLabel ? spacing.mui.lg : spacing.mui.lg,
            paddingRight: hideLabel ? spacing.mui.lg : spacing.mui.lg,
            background: 'transparent',
            borderRadius: spacing.mui.sm,
            justifyContent: hideLabel ? 'center' : 'flex-start',
            alignItems: 'center',
            gap: hideLabel ? 0 : spacing.mui.sm,
            display: 'flex',
            cursor: 'pointer',
            minWidth: hideLabel ? 48 : 'auto',
            '&:hover': {
              backgroundColor: colors.interaction.hover
            }
          }}
        >
          <ListItemIcon sx={{ 
            minWidth: 0, 
            color: colors.text.primary,
            justifyContent: 'center',
            width: 16,
            height: 16,
            marginRight: hideLabel ? 0 : 1,
            display: 'flex',
            alignItems: 'center'
          }}>
            <PersonIcon />
          </ListItemIcon>
          {!hideLabel && (
            <Typography sx={{ 
              textAlign: 'left', 
              color: colors.text.primary, 
              fontSize: typography.fontSize.medium, 
              fontFamily: typography.fontFamily.primary, 
              fontWeight: typography.fontWeight.bold, 
              lineHeight: typography.lineHeight.tight,
              whiteSpace: 'nowrap',
              minWidth: 'max-content',
              flex: 1,
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "120px",
            }}>
              {username}
            </Typography>
          )}
        </Box>
      </Tooltip>
      
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        transformOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <MenuItem
          onClick={() => {
            handleClose();
            onLogout();
          }}
        >
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
}
